enum EnvironmentVariable {
  API_KEY = "API_KEY",
  API_ENDPOINT = "API_ENDPOINT",
};

export default EnvironmentVariable;
